import script from "./AddProductTip.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddProductTip.vue?vue&type=script&lang=ts&setup=true"

import "./AddProductTip.vue?vue&type=style&index=0&id=7e54448c&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e54448c"]])

export default __exports__